export const addReplyButtonFunction = ({
  isInteractiveList,
  nodes,
  setNodes,
  nodeId,
}) => {

  const selectedNode = nodes.find((node) => node.id === nodeId);

  if (!selectedNode) {
    return;
  }

  const currentButtons = selectedNode.data?.buttons ?? [];
  const maxButtons = isInteractiveList ? 10 : 3;
  if (currentButtons.length >= maxButtons) {
    return;
  }
  const updatedButtons = [...currentButtons, { title: "" }];
  setNodes((previousNodes) =>
    previousNodes.map((node) => {
      if (node.id !== nodeId) {
        return node;
      }

      return {
        ...node,
        data: {
          ...node.data,
          buttons: updatedButtons,
        },
      };
    })
  );
};